import React from 'react'
import Header from '../Components/Header/header'
import '../Components/BreadCrumb/breadcrumb.css';
import About from '../Components/About/about';
import CounterSection from '../Components/CounterSection/countersection';
import Footer from '../Components/Footer/footer';

const AboutMe = () => {
  return (
    <div>
        <Header/> 
        <div className="breadcrumb-container">
        <div className="breadcrumb">
          <h2>About Me</h2>
        </div>
      </div>
      <About />
      <CounterSection/>
      <Footer/>
      
    </div>
  )
}

export default AboutMe